import React from 'react';
import {Trans} from 'react-i18next';
import classnames from 'classnames';
import {connect} from 'formik';

export default connect(function ElevatedButton({
  form,
  formik: {isSubmitting},
  type,
  onClick = () => {},
  faIcon,
  text,
  disabled = false,
}) {
  const getText = () => {
    switch (type) {
      case 'submit': {
        return (
          <div style={{visibility: isSubmitting ? 'hidden' : 'visible'}}>
            <i className="fa fa-save" />{' '}
            <Trans i18nKey="p.s.customerprofile.save">Save</Trans>
          </div>
        );
      }
      case 'edit': {
        return (
          <div>
            <i className="fa fa-pencil-alt" />{' '}
            <Trans i18nKey="p.s.customerprofile.edit">Edit</Trans>
          </div>
        );
      }
      case 'refresh': {
        return (
          <div>
            <i className="fa fa-refresh" />{' '}
            <Trans i18nKey="p.s.recommendation.rule.reload.status">
              Reload Status
            </Trans>
          </div>
        );
      }
      case 'custom': {
        return (
          <div>
            <i className={`fa ${faIcon}`} /> {text}
          </div>
        );
      }
    }
  };

  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      onClick={onClick}
      form={form && form}
      className={classnames({
        'kt-spinner': isSubmitting || disabled,
        'kt-spinner-v2': isSubmitting || disabled,
        'kt-spinner--center': isSubmitting || disabled,
        'kt-spinner--sm': isSubmitting || disabled,
        'kt-spinner--warning': isSubmitting || disabled,
      })}
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        color: '#5d78ff',
      }}
      disabled={isSubmitting || disabled}
    >
      {getText()}
    </button>
  );
});
